import React, { useState } from 'react';
import c from 'classnames';
import { useWindowDimensions, Button } from '@uncinc/uncinc-react-kitchen-sink';

import { Logo } from '../../components';

import { SCREEN_WIDE } from '../../config/constants';

import './style.scss';

export const SCROLL_UP = 'up';
export const SCROLL_DOWN = 'down';

const NAVIGATION_TOP_HEIGHT = 290;
const NAVIGATION_TOP_MIN_HEIGHT = 80;
const NAVIGATION_MIN_PERCENTAGE = 25;

import NavigationMainMenu from './NavigationMainMenu';

const Navigation = ({ setSearchBarVisible, searchbarVisible, isOnSearchPage }) => {

  const [menuToggled, setMenuToggled] = useState(false);
  const { width } = useWindowDimensions();
  const navigationClasses = c('Navigation', {
    'Navigation--active': menuToggled,
    'show-nav': menuToggled,
    'Navigation--desktop': width >= SCREEN_WIDE,
    'Navigation--mobile': width < SCREEN_WIDE,
  });

  if (menuToggled) {
    document.body.classList.add('navigation-active');
  } else {
    document.body.classList.remove('navigation-active');
  }

  // Handle the scroll animation for the top navigation.
  window.onscroll = () => {
    if (width >= SCREEN_WIDE) {
      const documentTop = document.body.getBoundingClientRect().top;
      const totalHeight = NAVIGATION_TOP_HEIGHT;
      const minHeight = NAVIGATION_TOP_MIN_HEIGHT;
      const newHeight = totalHeight + documentTop;
      const height = newHeight > minHeight ? newHeight : minHeight;
      const percentageScrolled = parseInt((newHeight / totalHeight) * 100);
      const backgroundSizeInPercentage = percentageScrolled > NAVIGATION_MIN_PERCENTAGE ? percentageScrolled : NAVIGATION_MIN_PERCENTAGE;

      document.getElementById('Navigation__logo-container').style.height = `${height}px`;
      document.getElementById('Navigation__bg').style.height = `${height}px`;
      document.getElementById('Navigation__logo').style['background-size'] = `${backgroundSizeInPercentage}% auto`;
    }
  };

  return (
    <div className={navigationClasses}>
      <div className="Navigation__logo-container" id="Navigation__logo-container">
        <div id="Navigation__bg" />
        {!isOnSearchPage && (
          <Button
            primary={false}
            className="Button--secondary"
            id="Navigation__desktop_search_button"
            onClick={() => setSearchBarVisible(!searchbarVisible)}
          >
            Zoeken
          </Button>
        )}
        <div className="Navigation__logo-container__inner">
          <Logo menuToggled={menuToggled} setMenuToggled={setMenuToggled} />
        </div>
      </div>
      <NavigationMainMenu
        menuToggled={menuToggled}
        setMenuToggled={setMenuToggled}
        searchToggled={searchbarVisible}
        setSearchToggled={setSearchBarVisible}
        isOnSearchPage={isOnSearchPage}
      />
    </div>
  );
};

export default Navigation;
